import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  LayoutContainer,
  Layout,
  StepContainer,
  useWizardService,
  getCurrentStepId,
  getIsLastStep,
  CardFooter,
  SaveBlocker,
  CancelWizardDialog,
  StepList,
  StepBar,
  SummaryPanel,
} from '@bingads-webui-fluent-component/wizard';

import { layoutConfig } from './layout-config';
import { getLinkedInStepListConfig } from '../steps/step-list-config';
import { LinkedInStepFooter } from './step-footer';
import { summaryPanelConfig } from './summary-panel-config';

const CustomLayoutTemplate = ({ items }) => {
  const { state } = useWizardService();
  const currentStepId = getCurrentStepId(state);
  const config = layoutConfig[currentStepId];
  const {
    template: Template,
    noFooter,
    noStepList,
    customBlocker,
  } = config;

  let newItems = { ...items };
  if (noFooter) {
    newItems = _.omit(newItems, 'Footer');
    newItems = _.omit(newItems, 'CardFooter');
  }
  if (noStepList) {
    newItems = _.omit(newItems, 'StepList');
  }
  if (customBlocker) {
    newItems.Blocker = customBlocker;
  }
  return <Template items={newItems} />;
};

CustomLayoutTemplate.propTypes = {
  items: PropTypes.shape({}).isRequired,
};

export const CustomLayoutContainer = () => {
  const i18n = useContext(I18nContext);
  const { state } = useWizardService();
  const isLastStep = getIsLastStep(state);

  const stepListConfig = useMemo(() => getLinkedInStepListConfig(i18n), [i18n]);
  const nextButtonText = useMemo(() => (isLastStep ? _TL_('Go live') : _TL_('Save & go to next step')), [isLastStep]);

  return (
    <LayoutContainer template={CustomLayoutTemplate}>
      <Layout type="StepContainer" component={StepContainer} />
      <Layout type="StepList" component={StepList} config={stepListConfig} />
      <Layout type="StepBar" component={StepBar} config={stepListConfig} />
      <Layout type="SummaryPanel" component={SummaryPanel} config={summaryPanelConfig} />
      <Layout type="CancelDialog" component={CancelWizardDialog} />
      <Layout
        type="Footer"
        component={LinkedInStepFooter}
        nextButtonText={i18n.getString(nextButtonText)}
      />
      <Layout type="CardFooter" component={CardFooter} />
      <Layout type="Blocker" component={SaveBlocker} />
    </LayoutContainer>
  );
};
